"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'whatsapp.settings.systemCommunicationLabel': 'Comunicación del sistema',
    'whatsapp.settings.systemCommunicationHint': 'Cuando está habilitado, este bot se utilizará como canal de comunicación predeterminado del sistema. Solo un bot puede tener este rol a la vez.',
    'whatsapp.settings.systemCommunicationGroupLabel': 'Grupo para comunicaciones de bot a administrador',
    'whatsapp.settings.systemCommunicationGroupHint': 'Seleccione el grupo que el bot usará para enviar mensajes del sistema a los administradores. Se utiliza cuando la comunicación del sistema está habilitada.',
    'whatsapp.settings.selectGroup': 'Seleccionar grupo',
    'whatsapp.settings.title': 'Comunicaciones',
    'whatsapp.settings.description': 'Conecta y gestiona tu cuenta de WhatsApp mediante código QR.',
    'whatsapp.settings.status': 'Estado de conexión',
    'whatsapp.settings.statusConnected': 'Conectado',
    'whatsapp.settings.statusDisconnected': 'Desconectado',
    'whatsapp.settings.entityLabel': 'ID de entidad',
    'whatsapp.settings.logout': 'Cerrar sesión',
    'whatsapp.settings.entityIdLabel': 'ID de entidad (número de teléfono o identificador)',
    'whatsapp.settings.entityIdPlaceholder': 'Ingrese número de teléfono o ID de entidad',
    'whatsapp.settings.startLogin': 'Iniciar sesión',
    'whatsapp.settings.qrTitle': 'Código QR',
    'whatsapp.settings.qrInstruction': 'Abre WhatsApp en tu teléfono > Configuración > Dispositivos vinculados > Vincular un dispositivo > Escanea este código QR.',
    'whatsapp.settings.logsTitle': 'Registros de conexión',
    'whatsapp.settings.clearLogs': 'Limpiar',
    'whatsapp.settings.noLogs': 'Sin registros aún. Inicia un proceso de inicio de sesión para ver los registros de conexión.',
    'whatsapp.settings.noSettings': 'No hay configuración de número de teléfono. Crea una para empezar.',
    'whatsapp.settings.creator': 'Creado por',
    'whatsapp.settings.pinMessageLabel': 'Mensaje fijado',
    'whatsapp.settings.pinMessagePlaceholder': 'Contenido del mensaje que se fijará en la conversación',
    'whatsapp.settings.pinMessageHint': 'Si se completa, este mensaje se fijará para este número.',
    'whatsapp.settings.pingerLabel': 'Pinger',
    'whatsapp.settings.pingerHint': 'Cuando está habilitado, este bot envía periódicamente mensajes ping para mantener la conexión activa.',
    'whatsapp.settings.phoneTitle': 'Configuración de número de teléfono',
    'whatsapp.settings.formTitle': 'Configuración de WhatsApp',
    'whatsapp.settings.phoneLabel': 'Número de teléfono',
    'whatsapp.settings.titleLabel': 'Título',
    'whatsapp.settings.titlePlaceholder': 'ej. Cuenta principal, Línea de soporte...',
    'whatsapp.settings.phonePlaceholder': 'Ingrese número de teléfono (ej. +34123456789)',
    'whatsapp.settings.phoneHint': 'Ingrese el número de teléfono registrado en WhatsApp, incluyendo el código de país.',
    'whatsapp.settings.reportEmailLabel': 'Emails de informes',
    'whatsapp.settings.reportEmailPlaceholder': 'Agregue direcciones de email para informes de resumen',
    'whatsapp.settings.reportEmailHint': 'Los resúmenes de conversaciones grupales se enviarán a estas direcciones de email. Presione Enter para agregar cada email.',
    'whatsapp.settings.languageLabel': 'Idioma del bot',
    'whatsapp.settings.languageHint': 'Idioma que utiliza el bot al responder mensajes y generar resúmenes.',
    'whatsapp.settings.communicationTypeLabel': 'Tipo de comunicación',
    'whatsapp.settings.communicationTypeHint': 'Selecciona el canal de comunicación utilizado por este bot.',
    'whatsapp.settings.communicationType.wa': 'WhatsApp',
    'whatsapp.settings.communicationType.tele': 'Telegram',
    'whatsapp.settings.apiIdLabel': 'ID de API de Telegram',
    'whatsapp.settings.apiIdPlaceholder': 'Introduce el ID de API de Telegram',
    'whatsapp.settings.apiIdHint': 'ID numérico de API obtenido en my.telegram.org.',
    'whatsapp.settings.apiHashLabel': 'Hash de API de Telegram',
    'whatsapp.settings.apiHashPlaceholder': 'Introduce el hash de API de Telegram',
    'whatsapp.settings.apiHashHint': 'Cadena hash de API obtenida en my.telegram.org.',
    'whatsapp.settings.telegramApiLink': 'Obtener ID de API y Hash para cuenta de Telegram',
    'whatsapp.settings.botResponseConditionLabel': 'Condición de respuesta del bot',
    'whatsapp.settings.botResponseConditionPlaceholder': 'Describa cuándo debe responder el bot, p.ej. "Preguntas sobre horarios, precios o servicios"',
    'whatsapp.settings.botResponseConditionHint': 'El bot responderá a los mensajes de los usuarios que coincidan con esta condición. Deje vacío para desactivar las respuestas automáticas.',
    'whatsapp.settings.avatarLabel': 'Avatar',
    'whatsapp.settings.selectAvatar': '-- Seleccionar avatar --',
    'whatsapp.settings.avatarHint': 'Seleccione un avatar para respuestas con IA en este número de WhatsApp.',
    'whatsapp.settings.save': 'Guardar configuración',
    'whatsapp.settings.startAgent': 'Iniciar agente',
    'whatsapp.settings.stopAgent': 'Detener agente',
    'whatsapp.settings.agentRunning': 'Agente en ejecución',
    'whatsapp.settings.agentInitializing': 'Inicializando...',
    'whatsapp.settings.agent_status_active': 'Activo',
    'whatsapp.settings.agent_status_initializing': 'Inicializando',
    'whatsapp.settings.agent_status_inactive': 'Inactivo',
    'whatsapp.settings.telegramAuthTitle': 'Autenticación de Telegram',
    'whatsapp.settings.telegramCodeInstruction': 'Introduzca el código de verificación enviado a su cuenta de Telegram.',
    'whatsapp.settings.telegramCodePlaceholder': 'Código',
    'whatsapp.settings.telegramCodeSubmit': 'Enviar código',
    'whatsapp.settings.telegramPasswordInstruction': 'Introduzca la contraseña de autenticación de dos factores de Telegram.',
    'whatsapp.settings.telegramPasswordPlaceholder': 'Contraseña',
    'whatsapp.settings.telegramPasswordSubmit': 'Enviar contraseña',
    'whatsapp.settings.pop3.title': 'Informes por correo electrónico',
    'whatsapp.settings.pop3.description': 'Configurar servidores de correo electrónico para la recepción y monitoreo de informes.',
    'whatsapp.settings.pop3.add': 'Agregar servidor',
    'whatsapp.settings.pop3.empty': 'No hay servidores de correo configurados. Haga clic en "Agregar servidor" para crear uno.',
    'whatsapp.settings.pop3.untitled': 'Servidor sin nombre',
    'whatsapp.settings.pop3.host.label': 'Host del servidor',
    'whatsapp.settings.pop3.host.placeholder': 'pop.example.com',
    'whatsapp.settings.pop3.port.label': 'Puerto',
    'whatsapp.settings.pop3.port.placeholder': '995',
    'whatsapp.settings.pop3.username.label': 'Nombre de usuario',
    'whatsapp.settings.pop3.username.placeholder': 'Ingrese correo electrónico o nombre de usuario',
    'whatsapp.settings.pop3.password.label': 'Contraseña',
    'whatsapp.settings.pop3.password.placeholder': 'Ingrese contraseña',
    'whatsapp.settings.pop3.useTls.label': 'Usar TLS/SSL',
    'whatsapp.settings.pop3.enabled.label': 'Habilitado',
    'whatsapp.settings.pop3.save': 'Guardar configuración de correo',
    'whatsapp.settings.pop3.configure': 'Configurar correo',
    'whatsapp.settings.pop3.enabled.yes': 'Habilitado',
    'whatsapp.settings.pop3.enabled.no': 'Deshabilitado',
    'whatsapp.settings.pop3.actions': 'Acciones',
    'whatsapp.settings.pop3.remove': 'Eliminar',
    'whatsapp.settings.pop3.remove.failed': 'No se pudo eliminar la cuenta de correo.',
    'whatsapp.settings.pop3.remove.confirm': '¿Está seguro de que desea eliminar esta cuenta de correo?',
    'whatsapp.settings.pop3.removed': 'Cuenta de correo eliminada exitosamente.',
    'whatsapp.settings.pop3.saved': 'Configuración de correo guardada exitosamente.',
    'whatsapp.settings.pop3.host.required': 'El host del servidor es requerido.',
    'whatsapp.settings.pop3.gmail.switch': 'Gmail',
    'whatsapp.settings.pop3.gmail.description': 'Usar autenticación de Google para conectar tu cuenta de Gmail',
    'whatsapp.settings.pop3.gmail.connect': 'Conectar con Google',
    'whatsapp.settings.pop3.gmail.connecting': 'Conectando...',
    'whatsapp.settings.pop3.gmail.connected': 'Gmail conectado',
    'whatsapp.settings.pop3.gmail.disconnect': 'Desconectar Gmail',
    'whatsapp.settings.pop3.gmail.disconnect.confirm': '¿Estás seguro de que quieres desconectar Gmail?',
    'whatsapp.settings.pop3.gmail.disconnected': 'Gmail desconectado',
    'whatsapp.settings.pop3.gmail.disconnect.failed': 'No se pudo desconectar Gmail',
    'whatsapp.settings.pop3.gmail.auth.failed': 'No se pudo autenticar con Google',
    'whatsapp.settings.pop3.gmail.mode': 'Modo Gmail activo',
    'whatsapp.settings.pop3.gmail.mode.description': 'Los correos se leerán usando la autenticación de Google',
};
